export class UIUtil {
    static doesElementExist(selector: string): boolean {
        return document.querySelector(selector) !== null;
    }

    static waitForElementToExist(selector: string, delay: number, maxAttempts: number, successCallback: () => void, errorCallback: () => void, attemptCallback?: (attempt: number) => void): void {
        //const el = document.querySelector(selector) !== null;
        let attempts = 0;

        const tryFindingElement = () => {
            const element = document.querySelector(selector);
            if (element) {
                successCallback();
            } else {
                attempts++;
                if (attempts >= maxAttempts) {
                    errorCallback();
                } else {
                    if(attemptCallback) {
                        attemptCallback(attempts);
                    }
                    setTimeout(tryFindingElement, delay);
                }
            }
        };

        tryFindingElement();
    }
    
    static registerDynamicClickEvent<T extends HTMLElement>(
        selector: string,
        callback: (event: MouseEvent, element: T) => void,
        parent: HTMLElement = document.body,
        // Listen in the capture phase by default so the delegated handler runs on the way
        // down to the target, before any descendant's bubble-phase stopPropagation() can
        // swallow the click (e.g. theme/menu JS). event.target is already correct in capture,
        // so the walk-up-and-match logic below is unaffected.
        useCapture: boolean = true
    ) {
        const handleClick = function (event: MouseEvent) {
            let target = event.target as HTMLElement;
            // Traverse up the DOM tree until we find an element matching our selector or reach the parent
            while (target && target !== parent) {
                if (target.matches(selector)) {
                    event.preventDefault();
                    callback(event, target as T);
                    return;
                }
                target = target.parentElement as HTMLElement;
            }
        }
        // Use event delegation by attaching the listener to a parent element that exists now
        parent.addEventListener('click', handleClick, useCapture);

        return function removeListener() {
            parent.removeEventListener('click', handleClick, useCapture);
        };
    }

    static registerDynamicFormSubmitEvent(
        selector: string,
        callback: (event: SubmitEvent, form: HTMLFormElement) => void,
        parent: HTMLElement = document.body
    ) {
        const handleSubmit = function (event: SubmitEvent) {
            let target = event.target as HTMLElement;
            while (target && target !== parent) {
                if (target.matches(selector) && target instanceof HTMLFormElement) {
                    event.preventDefault();
                    callback(event, target);

                    return;
                }
                target = target.parentElement as HTMLElement;
            }
        };

        parent.addEventListener('submit', handleSubmit);

        // Return a function that can be called to remove the event listener
        return function removeListener() {
            this.Logger.trace("Removing submit event listener");
            parent.removeEventListener('submit', handleSubmit);
        };
    }

    static addToEndOfBody(html: string): void {
        document.body.insertAdjacentHTML('beforeend', html);
    }

    static trySetInnerHTML(selector: string, html: string): boolean {
        const element = document.querySelector(selector);
        if (element) {
            element.innerHTML = html;
            return true;
        } else {
            return false;
        }
    }

    static hideElement(selector: string): boolean {
        const element = document.querySelector(selector) as HTMLElement;
        if (element) {
            element.style.setProperty('display', 'none', 'important');
            return true;
        } else {
            return false;
        }
    }

    static showElement(selector: string): boolean {
        const element = document.querySelector(selector) as HTMLElement;
        if (element) {
            element.style.setProperty('display', 'block', 'important');
            return true;
        } else {
            return false;
        }
    };

    static getDataAttribute(selector: string, key: string): string | null {
        return UIUtil.getDataset(selector)?.[key] ?? null;
    };

    static getDataAttributeAsInt(selector: string, key: string): number | null {
        const value = UIUtil.getDataAttribute(selector, key);
        if (value === null) {
            return null;
        }
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? null : parsed;
    };

    static getDataset(selector: string): DOMStringMap | null {
        const element = document.querySelector(selector) as HTMLElement;
        if (element) {
            return element.dataset;
        } else {
            return null;
        }
    };



}